<template>
    <!-- 导航 -->
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">我的藏品</span>
        </template>
    </NavBar>

    <div class="head">
        <span class="check-item" :class="{active: type == 'normal'}" @click="changeType('normal')">已获得藏品</span>
        <span class="check-item" :class="{active: type == 'compose'}" @click="changeType('compose')">合成藏品</span>
        <section class="layout">
            <div class="left" :class="{imgActive: order != 'DESC'}" @click="toggleOrder"></div>
            <div class="right" :class="{imgActive: ! row}" @click="row = ! row"></div>
        </section>
    </div>
    <div class="up-and-down" v-if="row">
        <div class="cont-box" v-for="entity in entities" :key="entity.id" @click="entity.showParent ? ($store.state.containerEntity = entity,$router.push(`/product/${entity.product.parent.id}`)) : jumpLink(entity.detail_url ? entity.detail_url : ('/entity/' + entity.id))">
            <div class="cover-box">
                <img class="cover" :src="entity.showParent ? entity.product.parent.cover : entity.product.cover" />
                <div class="music" v-if="entity.product.is_music">音乐</div>
            </div>
            <section class="content">
                <span class="title ellipsis2">{{ entity.showParent ? entity.product.parent.name : entity.product.name }}</span>
                <p class="time">收藏时间 {{ dateFormat('YYYY-mm-dd HH:ii:ss', entity.created_at) }}</p>
                <div class="foot-box">
                    <div class="compose" @click.stop="showEntityAlter = true;showEntity = entity" v-if="entity.showParent || entity.showCompose || entity.can_deliver">
                        <img src="@/assets/images/game-icon.png" v-if="!$newYearStyle"/>
                        <img src="@/assets/images1/newYear/game-icon.png" v-else/>
                        玩法
                        <van-icon name="arrow" size="10" color="#3465DB" />
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="right-and-left" v-else>
        <van-row type="flex" gutter="10" justify="space-between">
            <van-col span="12" v-for="entity in entities" :key="entity.id">
                <div class="box" @click="entity.showParent ? ($store.state.containerEntity = entity,$router.push(`/product/${entity.product.parent.id}`)) : jumpLink(entity.detail_url ? entity.detail_url : ('/entity/' + entity.id))">
                    <div class="cover-box">
                        <img class="cover" :src="entity.showParent ? entity.product.parent.cover : entity.product.cover" />
                        <div class="music" v-if="entity.product.is_music">音乐</div>
                    </div>
                    <section class="content">
                        <p class="title ellipsis2">{{ entity.showParent ? entity.product.parent.name : entity.product.name }}</p>
                        <p class="time">{{ dateFormat('YYYY-mm-dd HH:ii:ss', entity.created_at) }}</p>
                        <div class="foot-box">
                            <div class="compose" @click.stop="showEntityAlter = true;showEntity = entity" v-if="entity.showParent || entity.showCompose || entity.can_deliver">
                                <img src="@/assets/images/game-icon.png" v-if="!$newYearStyle"/>
                                <img src="@/assets/images1/newYear/game-icon.png" v-else/>
                                玩法
                                <van-icon name="arrow" size="10" color="#3465DB" />
                            </div>
                        </div>
                    </section>
                </div>
            </van-col>
        </van-row>
    </div>
    <van-overlay :show="showEntityAlter" class="success-overlay">
        <div class="game-box" :class="{new_year_tab: $newYearStyle}">
            <img src="@/assets/images/close-detail-toast.png" class="close" @click="showEntityAlter = false" v-if="!$newYearStyle">
            <img src="@/assets/images1/newYear/close-detail-toast.png" class="close" @click="showEntityAlter = false" v-else>
            <img src="@/assets/images/game-box.png" class="img" v-if="!$newYearStyle">
            <img src="@/assets/images1/newYear/game-box.png" class="img" v-else>
            <div class="button" @click.stop="openEntity = showEntity;successType = 'unpuck'" v-if="showEntity.showParent">开启盲盒</div>
            <div class="button" @click.stop="$router.push('/product/' + showEntity.product.id + '/compose')" v-if="showEntity.showCompose">藏品合成</div>
            <div class="button" @click.stop="$router.push('/delivery/submit?entity_id=' + showEntity.id)" v-if="showEntity.can_deliver">心意投递</div>
        </div>
    </van-overlay>
    <div v-show="! loading && entities.length <= 0" class="list-null">
        <van-empty
            :image="require('@/assets/images/kong.png')"
            description="暂无数字藏品"
        v-if="!$newYearStyle"/>
        <van-empty
            :image="require('@/assets/images1/newYear/kong.png')"
            description="暂无数字藏品"
        v-else/>
    </div>

    <van-overlay :show="successType == 'unpuck'" class="success-overlay">
        <div class="unpack">
            <img src="@/assets/images/blindbox.png" class="blindbox">
            <p class="title">藏品盲盒</p>
            <a href="javascript:;" class="button" @click="successType = 'confirm'">打开盲盒</a>
            <img src="@/assets/images/close.png" class="close" @click="successType = ''">
        </div>
    </van-overlay>
    <van-overlay :show="successType == 'confirm'" class="success-overlay">
        <div class="confirm">
            <img :src="openEntity.product.cover" class="cover">
            <p class="title">恭喜获得</p>
            <p class="title">{{openEntity.product.name}}</p>
            <a href="javascript:;" @click="$store.state.openEntity = true;$router.push('/entity/' + openEntity.id)" class="button">查看详情</a>
        </div>
    </van-overlay>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>